module.exports = __webpack_public_path__ + "img/losetas-seguridad.2cd5846a.jpg";